import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, Chip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ReactMarkdown from 'react-markdown';
import { supabase } from '../../../lib/supabase';
import NoticeInputForm from '../../../components/community/NoticeInputForm';
import { useAuth } from '../../../context/AuthContext';

const NoticesPage = () => {
  const { isAdmin } = useAuth();
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotices = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from('notices')
      .select('*')
      .order('is_pinned', { ascending: false })
      .order('created_at', { ascending: false });
    setNotices(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" fontWeight={900} color="primary.main" gutterBottom>
          <span role="img" aria-label="공지">📢</span> 공지사항
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          서비스 이용에 꼭 필요한 공식 안내와 업데이트를 확인하세요.
        </Typography>
        {isAdmin && <NoticeInputForm onSuccess={fetchNotices} />}
        {loading ? (
          <Typography>로딩 중...</Typography>
        ) : notices.length === 0 ? (
          <Typography color="text.secondary">등록된 공지사항이 없습니다.</Typography>
        ) : (
          notices.map((notice) => (
            <Paper
              key={notice.id}
              elevation={3}
              sx={{
                p: 4,
                mb: 3,
                borderLeft: '6px solid',
                borderColor: notice.is_pinned ? 'primary.main' : 'grey.300',
                background: notice.is_pinned ? 'rgba(33, 150, 243, 0.04)' : 'background.paper',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <InfoIcon color="primary" sx={{ mr: 1 }} />
                <Typography variant="h5" fontWeight={700} color="primary.main" sx={{ mr: 2 }}>
                  {notice.title}
                </Typography>
                {notice.is_pinned && (
                  <Chip label="공지" color="primary" size="small" sx={{ fontWeight: 700 }} />
                )}
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {new Date(notice.created_at).toLocaleString()}
              </Typography>
              <Box sx={{ fontSize: '1.1rem', lineHeight: 1.7 }}>
                <ReactMarkdown>{notice.content}</ReactMarkdown>
              </Box>
            </Paper>
          ))
        )}
      </Box>
    </Container>
  );
};

export default NoticesPage; 